import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import GetAllFormFields from '../../../../components/_utils/formUtils'

// import {FormUtils as GetAllFormFields, TableComp} from 'sz-react-utils'
import { Button, Card, Col, Form, notification, Row, Select, Table } from 'antd'
import _ from 'lodash'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request from '../../../../request'
import { connect } from 'react-redux'
import moment from 'moment'
import Each from 'async/each'

// following variables needed for update country

const Option = Select.Option
let sourceOptions = ['Direct', 'Newspaper', 'Facebook', 'Google', 'Seminar', 'Education Fair', 'School/College Event', 'Conopy', 'Instagram', 'Justdial', 'Website', 'Friend Reference']

@Form.create()
class AddRawInquiry extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            list: [],
            countryArr: [],
            modeArr: [],
            totalPreference: [],
            city: null,
            country: null,
            savedCourses: [],
            preferedCountries: [],
            testTypeList: [],
            testTypeArray: [],
            genderArr: [],
            maritalArr: [],
            speaking: 0,
            reading: 0,
            writing: 0,
            listening: 0,
            ieltsOverallScore: 0,
            nextYears:[],
            phoneCodes:[],
            dealingCountryArr:[],
            dealingPhoneCodes:[]
        }
        this.loadCountries();
        this.loadDealingCountries();

    }
    getAllTestTypes = async () => {
        let response = await Request.getAllTestTypes({
            results: 1000,
            count: 1000
        });
        if (response && response.data) {
            let testTypeList = [];
            let testTypeArray = [];
            response.data.map((testTypeData) => {
                testTypeList.push(testTypeData.testType)
                if (testTypeArray[testTypeData.testType] == undefined) {
                    testTypeArray[testTypeData.testType] = {};
                }
                testTypeArray[testTypeData.testType] = testTypeData;
            })
            this.setState({
                testTypeList: testTypeList,
                testTypeArray: testTypeArray
            });
        }
    }

    getAllGenders = async () => {
        let response = await Request.getGenderDetails({
            results: 1000,
            count: 1000
        })
        let genderObject = [];
        response.data && response.data.map((gender) => {
            genderObject.push(gender.genderName)
        })
        this.setState({ genderArr: genderObject })
    }

    getAllMaritalStatus = async () => {
        let response = await Request.getMaritalStatusDetails({
            results: 1000,
            count: 1000
        })
        let maritalObject = [];
        response.data && response.data.map((marital) => {
            maritalObject.push(marital.maritalStatus)
        })
        this.setState({ maritalArr: maritalObject })
    }

    calculateOverAll = () => {
        let totalSum = 0;
        let { listening, writing, reading, speaking } = this.state;
        if (listening > 0) {
            totalSum += listening;
        }
        if (writing > 0) {
            totalSum += writing;
        }
        if (reading > 0) {
            totalSum += reading;
        }
        if (speaking > 0) {
            totalSum += speaking;
        }
        let ieltsOverallScore = 0;
        if (totalSum >= 11) {
            let data = 0;
            totalSum = Math.floor(totalSum);
            if (totalSum % 2 != 0) {
                data = totalSum + 1;
            } else {
                data = totalSum;
            }
            ieltsOverallScore = parseFloat(data / 4).toFixed(1);
        }
        this.setState({ ieltsOverallScore });
        this.props.form.setFieldsValue({ ieltsOverallScore });
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {

                let values = _.clone(valData)

                values.totalPreference = this.state && this.state.totalPreference

                let x = null

                if (this.state.id) {

                    values = { ...values, _id: this.state.id }

                    dispatch(showLoader())

                    let data = []
                    if(values.totalPreference && values.totalPreference.length) {
                        _.each(values.totalPreference, (item) => {
                            let abc = {}
                            abc.country = item.country.countryName
                            abc.city = item.city.cityName
                            abc.countryId = item.country._id
                            abc.cityId = item.city._id
                            data.push(abc)
                        })
                    }
                    
                    values.totalPreference = data

                    x = await Request.updateRawInquiry(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.message
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.message
                        })
                    }
                } else {
                    dispatch(showLoader())

                    let data = []
                    if(values.totalPreference && values.totalPreference.length) {
                        _.each(values.totalPreference, (item) => {
                            let abc = {}
                            abc.country = item.country.countryName
                            abc.city = item.city.cityName
                            abc.countryId = item.country._id
                            abc.cityId = item.city._id
                            data.push(abc)
                        })
                    }
                    values.totalPreference = data


                    x = await Request.addRawInquiry(values)
                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: x.message
                        })

                        form.resetFields()
                        this.setState({
                            totalPreference: [],
                            current: 0

                        })
                        if (!this.state.id) {
                            this.props.form.setFieldsValue({
                                selectInquiryType: 'STUDENT',
                                mode: 'Personal',
                                location: 'Direct',
                                gender: 'Male',
                                dateOfBirth: moment().add(-18, 'year')
                            })
                        }

                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.message
                        })
                    }
                }
            }
        })
    }

    loadDealingCountries = () => {
        let params = {
          results: 100,
          sortField: "countryName",
          sortOrder: "ascend",
        };
        Request.getDealingCountries({ ...params }).then((resp) => {
          let dealingPhoneCodes = [];
          resp.data = resp.data.reduce((temp, vv) => {
            if (vv.countryPhoneCode) {
              dealingPhoneCodes.push(vv.countryPhoneCode);
            }
            temp.push({ ...vv });
            return temp;
          }, []);
          this.setState({ dealingCountryArr: resp.data,  dealingPhoneCodes: dealingPhoneCodes });
        })
      }

    loadCountries = () => {
        let params = { results: 100, sortField: 'countryName', sortOrder: 'ascend' }
        Request.getCountriesWithoutAuth({ ...params })
            .then(resp => {
                let phoneCodes= [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ ...vv })
                    if(vv.countryPhoneCode) {
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    return temp
                }, [])
                this.setState({ countryArr: resp.data, phoneCodes:phoneCodes })
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadCities = (countryId) => {
        return new Promise(async resolve => {
            let data = await Request.loadCitiesByCountry(countryId)
            this.setState({ cityArr: data.result })
        })
    }

    getAllSource = async () => {
        let response = await Request.getSourceDetails({
            results: 1000,
            count: 1000
        })
        let sourceObject = [];
        response.data && response.data.map((source) => {
            sourceObject.push(source.sourceName)
        })
        this.setState({ modeArr: sourceObject })
    }
    getNextFiveYears = async() => {
        let years = []
       for(let i=0; i<=5; i++) {
         let year = new Date().getFullYear() + i
         years.push(year.toString())
       }
       this.setState({nextYears:years})
     }

    async componentDidMount() {
        await this.getAllSource();
        await this.getAllTestTypes();
        await this.getAllGenders();
        await this.getNextFiveYears()
        await this.getAllMaritalStatus();
        const { dispatch } = this.props

        let searchParams = new URLSearchParams(this.props.search)
        let rawInquiryId = searchParams.get('id')
        this.setState({
            id: rawInquiryId
        })


        dispatch(showLoader())
        if (rawInquiryId) {
            Request.getRawInquiryIdDetail({ _id: rawInquiryId }).then(({ data, error, message }) => {
                if (!error) {

                    this.setState({
                        id: data._id
                    })

                    this.setState({ savedCourses: data.saved_course });
                    this.setState({ preferedCountries: data.preferedCountry });
                    this.props.form.setFieldsValue({
                        studentName: data && data.studentName,
                        dateOfBirth: data && moment(data.dateOfBirth),
                        selectInquiryType: data && data.selectInquiryType,
                        gender: data && data.gender,
                        mode: data && data.mode,
                        mobile: data && data.mobile,
                        location: data && data.location,
                        watsupp: data && data.watsupp,
                        emailId: data && data.emailId,
                        facebookEmail: data && data.facebookEmail,
                        whichYearPlanningToGo: data && data.whichYearPlanningToGo,
                        testType: data && data.testType,
                        enqType: data && data.enqType,

                        testScore: data && data.testScore,
                        reading: data && data.reading,
                        writing: data && data.writing,
                        listening: data && data.listening,
                        speaking: data && data.speaking,
                        marital_status: data && data.marital_status,
                        rawInquiryStatus:data && data.rawInquiryStatus,
                        address: data && data.address,
                        board_university: data && data.board_university,
                        overall_percentage: data && data.overall_percentage,
                        highest_qualification: data && data.highest_qualification,
                        passing_year: data && data.passing_year,
                        company_name: data && data.company_name,
                        industry: data && data.industry,
                        designation: data && data.designation,
                        job_period: data && data.job_period,
                        gap_years: data && data.gap_years,
                    })

                    if (data && data.totalPreference) {
                        let x = []
                        Each(data.totalPreference, async (item, done) => {

                            let country = {}
                            let city = {}
                            country._id = item.countryId
                            country.countryName = item.country
                            city._id = item.cityId
                            city.cityName = item.city

                            x.push({ country, city })
                            done()
                        }
                            ,
                            () => {
                                if (!this.state.edited) {
                                    this.setState({ totalPreference: x })
                                }
                            }
                        )
                    }

                } else {
                    notification
                        .error({
                            message: 'Error Getting Data',
                            description: message
                        })
                }
            }
            )
        }

        dispatch(hideLoader())

        this.props.form.setFieldsValue({
            selectInquiryType: 'STUDENT',
            mode: 'Personal',
            gender: 'Male',
            location: 'Direct',
            dateOfBirth: moment().add(-18, 'year')
        })

    }

    render() {
        let {
            id,
            savedCourses,
            preferedCountries,
            testTypeList,
            testTypeArray,
            testTypeScore = [],
            maritalArr,
            genderArr
        } = this.state;

        const inputSchma = {
            fields: [
                {
                    label: 'Select Inquiry Type:',
                    key: 'selectInquiryType',
                    required: true,
                    showSearch: true,
                    type: 'select',
                    options: ['IELTS', 'STUDENT', 'VISITOR'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            selectInquiryType: v
                        })
                    }
                },
                {
                    label: 'Student Name ',
                    key: 'studentName',
                    required: true
                },
                {
                    label: 'Date Of Birth',
                    key: 'dateOfBirth',
                    type: 'date'
                },
                {
                    key: 'gender',
                    required: true,
                    type: 'select',
                    defaultValue: 'nfjw',
                    options: genderArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            gender: v
                        })
                    }
                },
                {
                    label: 'Mode',
                    key: 'mode',
                    type: 'select',
                    showSearch: true,
                    options: this.state.modeArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({ mode: v })

                    }
                },
                {
                    label: 'Source',
                    key: 'location',
                    type: 'select',
                    options: sourceOptions,
                    onChange: v => {
                        this.props.form.setFieldsValue({ location: v })
                    }
                },
                {
                    label:'Status',
                    key:'rawInquiryStatus',
                    type:'select',
                    required:true,
                    options:['Active', 'Inactive'],
                    onChange:v=>{
                        this.props.form.setFieldsValue({rawInquiryStatus:v})
                    }
                },
                {
                    label: "Country Code",
                    key: "countryCode",
                    type: "select",
                    showSearch: true,
                    required:true,          
                    options: this.state.dealingPhoneCodes,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ countryCode: v });
                    },
                },
                {
                    label: 'Mobile ', key: 'mobile', type: 'number', required: true,
                    style: { width: 275 }
                }
            ]
        }

        const inputProfileSchma = {
            fields: [
                {
                    label: 'Marital Status:',
                    key: 'marital_status',
                    type: 'select',
                    options: maritalArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            marital_status: v
                        })
                    }
                },
                {
                    label: "Select Test Type",
                    key: "testType",
                    type: "select",
                    options: testTypeList,
                    hidden: (this.state.haveEnglishTestScore == false),
                    required: (this.state.haveEnglishTestScore == true),
                    onChange: (v) => {
                        let testTypeObject = testTypeArray[v] != undefined ? testTypeArray[v] : {};
                        let testTypeScore = [];
                        if (testTypeObject.endNumber) {
                            for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                                testTypeScore.push(index.toString());
                            }
                        }
                        this.setState({ testType: v, testTypeScore });
                        this.props.form.setFieldsValue({ testType: v });
                    },
                },
                {
                    label: "Speaking Score",
                    key: "speaking",
                    type: "select",
                    options: testTypeScore,
                    disabled: !this.state.testType,
                    onChange: (v) => {
                        this.setState({ speaking: v }, () => {
                            // this.calculateOverAll();
                        });
                        this.props.form.setFieldsValue({ speaking: v });
                    },
                },
                {
                    label: "Listening Score",
                    key: "listening",
                    type: "select",
                    options: testTypeScore,
                    disabled: !this.state.testType,
                    onChange: (v) => {
                        this.setState({ listening: v }, () => {
                            // this.calculateOverAll();
                        });
                        this.props.form.setFieldsValue({ listening: v });
                    },
                },
                {
                    label: "Writing Score",
                    key: "writing",
                    type: "select",
                    options: testTypeScore,
                    disabled: !this.state.testType,
                    onChange: (v) => {
                        this.setState({ writing: v }, () => {
                            // this.calculateOverAll();
                        });
                        this.props.form.setFieldsValue({ writing: v });
                    },
                },
                {
                    label: "Reading Score",
                    key: "reading",
                    type: "select",
                    options: testTypeScore,
                    disabled: !this.state.testType,
                    onChange: (v) => {
                        this.setState({ reading: v }, () => {
                            // this.calculateOverAll();
                        });
                        this.props.form.setFieldsValue({ reading: v });
                    },
                },
                {
                    label: "OverallScore",
                    key: "ieltsOverallScore",
                    type:'select',
                    options:testTypeScore,
                    onChange: (v) => {
                        this.setState({ ieltsOverallScore: v });
                        this.props.form.setFieldsValue({ ieltsOverallScore: v });
                    },
                },
                {
                    label: 'Address ',
                    key: 'address'
                },
                {
                    label: 'Company Name ',
                    key: 'company_name'
                },
                {
                    label: 'Industry ',
                    key: 'industry'
                },
            ]
        }

        const inputProfile2Schma = {
            fields: [
                {
                    label: 'Board University ',
                    key: 'board_university'
                },
                {
                    label: 'Overall Percentage ',
                    key: 'overall_percentage'
                },
                {
                    label: 'Highest Qualification ',
                    key: 'highest_qualification'
                },
                {
                    label: 'Passing Year ',
                    key: 'passing_year'
                },
                {
                    label: 'Designation ',
                    key: 'designation'
                },
                {
                    label: 'Job Period ',
                    key: 'job_period'
                },
                {
                    label: 'Gap Years ',
                    key: 'gap_years'
                },
            ]
        }

        const inputSchm = {
            fields: [

                { label: 'Whatsapp ', key: 'watsupp', type: 'number', style: { width: 275 } },
                { label: 'Email Id ', key: 'emailId' },
                { label: 'Facebook Id ', key: 'facebookEmail' },
                {
                    label: 'Year Planning To Go',
                    key: 'whichYearPlanningToGo',
                    type:'select',
                    options:this.state.nextYears,
                    onChange:v=>{
                        this.props.form.setFieldsValue({whichYearPlanningToGo:v})
                    }
                },
                {
                    label: 'Study Level',
                    key: 'enqType',
                    type: 'select',
                    options: ['Under Graduate', 'Post Graduate', 'Schooling'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ enqType: v })
                    }
                }]
        }
        const column = [
            {
                title: 'Country',
                key: 'country',
                dataIndex: 'country',
                render: (item) => {
                    return item.countryName
                }
            },
            {
                title: 'City',
                key: 'city',
                dataIndex: 'city',
                render: (item) => {
                    return item.cityName
                }
            },
            {
                title: 'Action',
                key: 'operation',

                render: (val, record) => (

                    <button
                        onClick={() => {
                            let tt = this.state.totalPreference
                            tt = _.reject(tt, val)
                            this.setState({ totalPreference: tt })
                        }}>
                        Remove
                    </button>
                )
            }
        ]

        const {
            form: { getFieldDecorator }
        } = this.props


        // const submitFormLayout = {
        //     labelCol: {},
        //     wrapperCol: {
        //         xs: {span: 24, offset: 0},
        //         sm: {span: 24, offset: 0},
        //         md: {span: 24, offset: 0}
        //     }
        // }

        // const FIL = {
        //     labelCol: {
        //         xs: {span: 24},
        //         sm: {span: 8},
        //         md: {span: 8}
        //     },
        //     wrapperCol: {
        //         xs: {span: 24},
        //         sm: {span: 16},
        //         md: {span: 16}
        //     }
        // }

        return (
            <PageHeaderWrapper title={id ? 'Update Raw Inquiry' : 'Add Raw Inquiry'}>

                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card bordered={true}>

                        <Row>
                            <Col span={12}>
                                <GetAllFormFields
                                    inputSchema={inputSchma}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                    formItemLayout={{
                                        labelCol: { span: 10 },
                                        wrapperCol: { span: 12 }
                                    }}
                                />
                            </Col>
                            <Col span={12}>
                                <GetAllFormFields
                                    inputSchema={inputSchm}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                    formItemLayout={{
                                        labelCol: { span: 10 },
                                        wrapperCol: { span: 12 }
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={12}>
                                <GetAllFormFields
                                    inputSchema={inputProfileSchma}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                    formItemLayout={{
                                        labelCol: { span: 10 },
                                        wrapperCol: { span: 12 }
                                    }}
                                />
                            </Col>
                            <Col span={12}>
                                <GetAllFormFields
                                    inputSchema={inputProfile2Schma}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                    formItemLayout={{
                                        labelCol: { span: 10 },
                                        wrapperCol: { span: 12 }
                                    }}
                                />
                            </Col>
                        </Row>
                    </Card>

                    {/* <Card>
                        <Row>
                            <h2>Selected Courses</h2>
                            <table cellPadding={10} border={1}>
                                <thead>
                                    <tr>
                                        <th>Course Name</th>
                                        <th>Institute Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        savedCourses && savedCourses.length && savedCourses.map((savedCourse, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{savedCourse.course_name}</td>
                                                    <td>{savedCourse.institute_name}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </Row>
                    </Card> */}

                        {/* <Card>
                            <Row>
                                <h2>Prefered Country</h2>
                                <table cellPadding={10} border={1}>
                                    <tbody>
                                        {
                                            preferedCountries && preferedCountries.length && preferedCountries.map((preferedCountry, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th>Country</th>
                                                        <td>{preferedCountry}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Row>
                        </Card> */}

                    <Card>
                        <Row>
                            <Col span={8}>

                                <h4>Select Countries</h4>
                                <Select
                                    placeholder="Select Country"
                                    showSearch={true}
                                    optionFilterProp="children"
                                    value={this.state.country ? this.state.country._id : undefined}
                                    onChange={ei => {
                                        let singleCountry = _.find(this.state.countryArr, (item) => {
                                            return item._id === ei
                                        })

                                        if (singleCountry) {
                                            this.loadCities(singleCountry._id)
                                        }
                                        this.setState({ country: singleCountry, city: null })

                                    }}>
                                    {this.state.countryArr.map((val, index) => {
                                        return (
                                            <Option key={index}
                                                value={val._id}>
                                                {val.countryName}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Col>
                            <Col span={8}>

                                <h4>Select Cities</h4>
                                <Select
                                    placeholder="Select City"
                                    showSearch={true}
                                    optionFilterProp="children"
                                    value={this.state.city ? this.state.city._id : undefined}
                                    onChange={ei => {

                                        let singleCity = _.find(this.state.cityArr, (item) => {
                                            return item._id === ei
                                        })
                                        if (singleCity) {
                                            this.loadCities(singleCity._id)
                                        }
                                        this.setState({ city: singleCity })

                                    }}
                                >
                                    {this.state.cityArr && this.state.cityArr.map((val, index) => {
                                        return (
                                            <Option key={index}
                                                value={val._id}>
                                                {val.cityName}
                                            </Option>
                                        )
                                    })}
                                </Select>


                            </Col>

                            <Col span={8}>

                                <Button
                                    style={{
                                        marginTop: 25,
                                        marginBottom: 23,
                                        marginRight: 10
                                    }}
                                    size={'small'}
                                    onClick={() => {

                                        if (!this.state.country) {
                                            return notification.error({
                                                message: 'Choose Country'
                                            })
                                        }

                                        // if (!this.state.city) {
                                        //     return notification.error({
                                        //         message: 'Enter city'
                                        //     })
                                        // }
                                        if (this.state.country ) {
                                            let tt = this.state.totalPreference
                                            tt.push({
                                                country: this.state.country,
                                                city: this.state.city?this.state.city:''

                                            })
                                            this.setState({
                                                totalPreference: tt,
                                                city: null,
                                                country: null

                                            }, () => {

                                            })
                                        }
                                    }}>
                                    ADD TO PREFERENCES
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Table
                                    size={'small'}
                                    pagination={{
                                        defaultPageSize: 10,
                                        showSizeChanger: false,
                                        showQuickJumper: false
                                    }}
                                    bordered={true}
                                    columns={column}
                                    dataSource={this.state.totalPreference}
                                />
                            </Col>
                        </Row>
                        <Row> <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginTop: 10 }}
                            loading={this.props.loading}>
                            {id ? 'UPDATE' : 'SAVE'}
                        </Button></Row>
                    </Card>


                </Form>


            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddRawInquiry)


